// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawer footer{height:unset}.support-response-toggle{float:right;margin-top:-12px}.agent-ticket-drawer-footer .input-group-text{background-color:#6860e4;color:#fff;cursor:pointer}.agent-ticket-drawer-footer .inputGroupSelect{height:38px;margin-left:10px;margin-top:4px;width:unset}.attach-file-btn{margin-top:-30px}.support-conversation .message{white-space:pre-line}", ""]);
// Exports
module.exports = exports;
